<template>
  <div :class="'popover top in editable-container editable-popup ' + hideClass" :style="style">
      <div class="arrow"></div>
      <h3 class="popover-title">{{title}}</h3>
      <div class="popover-content">
        <div class="editableform-loading" style="display: none;"></div>
        <div class="form-group" v-if="errors.length" >
          <ul class="list-group">
            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <form class="form-inline editableform" @submit.prevent="submit">
          <div class="control-group form-group">
              <div class="form-group editable-input" style="position: relative;">
                <label class="form-control-sm">Nowa cena:</label>
                <input type="text"
                  style="width: 80px;"
                  class="form-control input-sm form-control-sm"
                  ref="focusItem"
                  v-model="itemPrice">
              </div>
              <div class="form-group">
                <label class="form-control-sm">Powód:</label>
                <select class="form-control form-control-sm" v-model="reason">
                  <option disabled value="">wybierz</option>
                  <option v-for="reason in reasons" :key="reason.value" v-bind:value="reason.value">
                    {{ reason.text }}
                  </option>
                </select>
              </div>
              <div class="editable-buttons">
                <button type="submit" class="btn btn-sm editable-submit torre-btn">
                  <i class="material-icons">
                  done
                  </i>
                </button>
                <button type="button" class="btn btn-default btn-sm editable-cancel" @click="closePopup">
                  <i class="material-icons">
                  clear
                  </i>
                </button>
              </div>
          </div>
        </form>
    </div>
  </div>
</template>
<script>

import uns from "underscore.string"
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import un from 'underscore'
import moment from 'moment'
import alertify from 'alertifyjs'
import priceUtils from "@/utils/PriceUtils"

export default {
  name: "EditableItemPopup",
  props: ['title'],
  data: () => ({
    popupStyle: "display: block;",
    sourceRect: "",
    itemPrice: "",
    hide: true,
    item: {},
    currentStore: {},
    errors: [],
    reason: "",
    reasons: [
      {
        value: "cosinus",
        text: "cosinus"
      },
      {
        value: "rabat",
        text: "rabat"
      },
      {
        value: "zwrot",
        text: "zwrot"
      },
      {
        value: "liczenie",
        text: "liczenie"
      },
      {
        value: "reklamacja",
        text: "reklamacja"
      },
      {
        value: "gratis",
        text: "gratis"
      },
      {
        value: "pomylka",
        text: "pomyłka"
      },
      {
        value: "wymiana",
        text: "wymiana"
      },
      {
        value: "pracownik",
        text: "pracownik"
      },
      {
        value: "inny",
        text: "inny"
      }
    ]
  }),
  created() {
    this.$eventHub.$on('openRevisionPopup', this.onOpenRevisionPopup);
  },
  mounted() {
    this.$refs.focusItem.focus()
  },
  destroyed() {
    this.$eventHub.$off('openRevisionPopup');
    document.onkeydown = null
  },
  computed: {
    style() {
      return this.popupStyle
    },
    hideClass() {
      return this.hide ? "hide-popup" : ""
    }
  },
  methods: {
    onOpenRevisionPopup(payload) {
      const that = this
      document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (evt.keyCode == 27) {
              that.closePopup();
          }
      };
      this.errors = []
      this.item = payload.item
      console.log(this.item)
      if (this.item.revision) {
        this.itemPrice = this.item.revision.newPrice
        this.reason = this.item.revision.description
      }
      this.currentStore = payload.currentStore
      this.sourceRect = payload.rect
      this.setPosition()
    },
    setPosition() {
      const top = this.sourceRect.top + window.scrollY - 100;
      const left = this.sourceRect.left - ((350 - this.sourceRect.width) / 2);
      this.popupStyle = "display: block; top:" + top + "px; left: " + left + "px;";
      this.hide = false
      setTimeout(()=> {
        this.$refs.focusItem.focus()
      }, 10)
    },
    closePopup() {
      document.onkeydown = null
      this.hide = true
      this.itemPrice = ""
      this.reason = ""
    },
    submit() {
      this.errors = []
      if (uns.isBlank(this.itemPrice)) {
        alertify.set('notifier','position', 'top-center');
        alertify.error("Podaj nową cenę.").delay(3);
        return false;
      }
      var price = priceUtils.convertToDouble(this.itemPrice)
      if (!un.isNumber(price)) {
        alertify.set('notifier','position', 'top-center');
        alertify.error("Podaj poprawną cenę.").delay(3);
        return false;
      }
      if (price < 0 ){
        alertify.set('notifier','position', 'top-center');
        alertify.error("Cena nie może być ujemna.").delay(3);
        return false;
      }
      if (uns.isBlank(this.reason)) {
        alertify.set('notifier','position', 'top-center');
        alertify.error("Wybierz powód.").delay(3);
        return false;
      }
      const revisionId = this.item.revision ? this.item.revision.revisionId : ""
      const data = {
        "revisionId": revisionId,
        "quantityChangeId": this.item.id,
        "description": this.reason,
        "newPrice": this.itemPrice,
        "user": userService.getCurrentUser().name,
        "storeId": this.currentStore.id,
        "storeName": this.currentStore.name,
        "created": moment().format("YYYY-MM-DD\THH:mm:ss")
      }
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/turnover/revision',
        data: data,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.$eventHub.$emit('revisionSaved', {
          data: res.data
        });
        this.closePopup();
      }).catch(err => {
        console.log(err);
        this.errors = un.map(err.response.data.errors, item => {
          return item.defaultMessage
        })
      })

    }
  }
}
</script>
<style lang="scss" scoped>

  button.editable-cancel {
    &:hover {
      background-color: #f1f1f1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/daily/RevisionPopup.vue